// The marks the Afrikaans training guides carry — one copy, shared by the app
// (src/lib/trainingGuides.ts) and the translators' tool
// (scripts/afrikaans-manual.mjs), so what one stamps the other reads. Plain ESM
// so node runs it without a build step; the types are in afrikaansMarks.d.mts.
// See docs/manuals/af/README.md for what the marks mean.

/** FNV-1a, 32-bit, hex, of the text with line endings normalised and trimmed. */
export function fingerprint(text) {
  const s = text.replace(/\r\n/g, '\n').trim()
  let h = 0x811c9dc5
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i)
    h = Math.imul(h, 0x01000193) >>> 0
  }
  return h.toString(16).padStart(8, '0')
}

/** GitHub's heading slug — the same rule scripts/check-manual-coverage.mjs uses. */
export function headingSlug(heading) {
  return heading.toLowerCase().replace(/[^\w\s-]/g, '').replace(/ /g, '-')
}

/** `## ` sections (outside code fences) with their raw text, heading line included — what a fingerprint is taken over. */
export function rawSections(md) {
  const out = []
  let inFence = false
  for (const line of md.split('\n')) {
    if (line.startsWith('```')) inFence = !inFence
    if (!inFence && line.startsWith('## ')) out.push({ heading: line.slice(3).trim(), lines: [line] })
    else if (out.length > 0) out[out.length - 1].lines.push(line)
  }
  return out.map(s => ({ heading: s.heading, text: s.lines.join('\n') }))
}

/** The line under an Afrikaans `##` heading: which English section it came from, and when. */
export const AF_MARKER = /^<!-- en:(\S+) hash:([0-9a-f]{8}) reviewed:(yes|no) -->$/

export function parseMarker(line) {
  const m = line.trim().match(AF_MARKER)
  return m ? { slug: m[1], hash: m[2], reviewed: m[3] === 'yes' } : null
}
